import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-card-patient',
  templateUrl: './card-patient.component.html',
  styleUrls: ['./card-patient.component.scss']
})
export class CardPatientComponent implements OnInit {
  @Input() name: string;
  @Input() lastName: string;
  @Input() folio: string;
  @Input() imageProfile: string;
  @Input() gender: string;
  @Input() email: string;
  @Input() active: boolean;
  @Input() short: boolean;
  @Input() cardStyles: {};
  @Output() profile: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se quiere ver el perfil de un paciente.
   */
  onEmitViewProfile(): void {
    this.profile.emit(true);
  }
}
